<template>
    <div class="put-into">      
      <div style="margin-bottom:.6rem">
        <span class="trend-title">投产数据</span>
        <el-select v-model="getType" placeholder="请选择">
          <el-option
            v-for="tts in options"
            :key="tts.value"
            :label="tts.label"
            :value="tts.value">
          </el-option>
        </el-select>
        
      </div>
      <table class="mytable">
        <thead>
          <tr>
            <th style="width:6%;">月份</th>
            <th v-for="(mon,index) in month" :key="index">{{mon}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="background:#203bd5;text-align:center">投入(万元)</td>
            <td>
              <el-input v-model="allData.oneInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.twoInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.threeInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.fourInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.fiveInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.sixInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.sevenInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.eightInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.nineInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.tenInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.elevenInput" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.twelveInput" placeholder="请输入内容"></el-input>
            </td>
          </tr>
          <tr>
            <td style="background:#203bd5;text-align:center">产出(万元)</td>
            <td>
              <el-input v-model="allData.oneIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.twoIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.threeIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.fourIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.fiveIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.sixIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.sevenIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.eightIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.nineIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.tenIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.elevenIncome" placeholder="请输入内容"></el-input>
            </td>
            <td>
              <el-input v-model="allData.twelveIncome" placeholder="请输入内容"></el-input>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="last-save">
         <el-button :loading="intoLoading" size="small" @click="saveInto" type="primary">保存</el-button>
      </div>
    </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data() {
    return {
      intoLoading:false,//加载状态
      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      getType:1,
      allData:{
        //投入
        oneInput:'',
        twoInput:'',
        threeInput:'',
        fourInput:'',
        fiveInput:'',
        sixInput:'',
        sevenInput:'',
        eightInput:'',
        nineInput:'',
        tenInput:'',
        elevenInput:'',
        twelveInput:'',
        //产出
        oneIncome:'',
        twoIncome:'',
        threeIncome:'',
        fourIncome:'',
        fiveIncome:'',
        sixIncome:'',
        sevenIncome:'',
        eightIncome:'',
        nineIncome:'',
        tenIncome:'',
        elevenIncome:'',
        twelveIncome:'',
      },
      //通用
      month:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
    }
  },
  mounted() {
    this.getInto()
  },
  methods: {
    //保存数据
    saveInto(){
      this.intoLoading = true;
      apis.saveProratio(this.allData).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.intoLoading = false;
        }else{
          this.$message.error(res.message);
          this.intoLoading = false;
          return;
        }
      })
    },
    //获取数据
    getInto(){
      apis.getProratio().then(res=>{
        if(res.code==10000){
          if(res.data.list.length!=0){
            this.allData = res.data.list[0]
          }
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.put-into{ padding-top: 10px;
  .last-save{ margin-top: 1rem;}
}
</style>


